import { render, staticRenderFns } from "./product-item-definition.vue?vue&type=template&id=21ac99d8&scoped=true&"
import script from "./product-item-definition.vue?vue&type=script&lang=js&"
export * from "./product-item-definition.vue?vue&type=script&lang=js&"
import style0 from "./product-item-definition.vue?vue&type=style&index=0&id=21ac99d8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ac99d8",
  null
  
)

export default component.exports